module.exports = __webpack_public_path__ + "img/1439231947.d9a68794.jpg";